import { type NavigateFunction } from 'react-router-dom'

import {
  CONTACT_CARE_TEAM_REQUEST_TYPES,
  type ContactCareTeamRequestType,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import { PAGE_ROUTES } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/routingConstants'

export const goToContactCareTeam = ({
  isDirectCareNavigatorExperience,
  navigate,
  typeOfRequest = CONTACT_CARE_TEAM_REQUEST_TYPES.USER_INITIATED_DEFAULT,
  mixpanelEntryPoint,
  mixpanelEntryPointDetail,
  preferenceDetail,
  showBackButton,
  replace,
}: {
  isDirectCareNavigatorExperience?: boolean
  navigate: NavigateFunction
  typeOfRequest?: ContactCareTeamRequestType
  mixpanelEntryPoint?: string
  mixpanelEntryPointDetail?: string
  preferenceDetail?: { [key: string]: any }
  showBackButton?: boolean
  replace?: boolean
}) => {
  if (isDirectCareNavigatorExperience) {
    navigate(
      { pathname: PAGE_ROUTES.CARE_NAVIGATOR_OPTIONS.SECURE_INDEX, search: 'hideXButton=true' },
      {
        state: { typeOfRequest, mixpanelEntryPoint, mixpanelEntryPointDetail, preferenceDetail },
        replace,
      },
    )
  } else {
    const searchParams = new URLSearchParams()
    if (showBackButton === false) {
      searchParams.set('showBackButton', 'false')
    }
    const searchParamsAsString = searchParams.toString()

    navigate(
      {
        pathname: PAGE_ROUTES.CARE_NAVIGATOR_OPTIONS.ONBOARD,
        ...(searchParamsAsString && { search: searchParamsAsString }),
      },
      {
        state: { typeOfRequest, mixpanelEntryPoint, mixpanelEntryPointDetail, preferenceDetail },
        replace,
      },
    )
  }
}

export const goToContactCareTeamConfirmation = (
  navigate: NavigateFunction,
  typeOfRequest?: ContactCareTeamRequestType,
  mixpanelEntryPoint?: string,
) => {
  navigate(`/secure/onboard/${PAGE_ROUTES.CONTACT_CARE_TEAM_CONFIRMATION}`, {
    state: { typeOfRequest, mixpanelEntryPoint },
  })
}
